<template>
  <div class="go-to-filters">
    <div
      class="filter-item d-flex grouped-inputs delete-wrapper"
      v-for="(filter, index) in filters"
      :key="index"
    >
      <div class="filter-input-item">
        <label>Attribute</label>
        <v-autocomplete
          :items="variables"
          item-text="variable"
          class="left-radius bordered"
          item-value="variable"
          v-model="filter.attribute"
          :error="!filter.attribute"
          :error-messages="!filter.attribute ? 'Filter is Required' : ''"
          outline
          solo
        >
        </v-autocomplete>
      </div>
      <div class="filter-input-item">
        <label>Select Operator</label>
        <v-autocomplete
          :items="operators"
          item-text="name"
          item-value="value"
          v-model="filter.operator"
          :error="!filter.operator"
          :error-messages="!filter.operator ? 'Operator is Required' : ''"
          class="bordered"
          outline
          solo
        ></v-autocomplete>
      </div>
      <div class="filter-input-item">
        <label>Value</label>
        <v-autocomplete
          :items="channelsData"
          v-model="filter.value"
          item-text="name"
          item-value="value"
          v-if="filter.attribute === 'channel'"
          :error="!filter.value"
          :error-messages="!filter.value ? 'Value is Required' : ''"
          outline
          class="bordered"
          solo
        >
        </v-autocomplete>
        <v-text-field
          outline
          v-model="filter.value"
          v-else
          :error="!filter.value"
          :error-messages="!filter.value ? 'Value is Required' : ''"
          class="bordered"
        >
        </v-text-field>
      </div>
      <div class="filter-input-item">
        <label>Select Condition</label>
        <v-select
          :items="['and', 'or']"
          v-model="filter.condition"
          :error="!filter.condition"
          class="right-radius bordered"
          :error-messages="!filter.operator ? 'Condition is Required' : ''"
          outline
          solo
        ></v-select>
      </div>
      <v-btn
        @click="deleteFilter(index)"
        fab
        small
        color=""
        class="delete-button"
        ><v-icon small color="#666">delete_outline</v-icon></v-btn
      >
    </div>
    <v-btn large round flat block class="primary--text" @click="addFilter">
      <v-icon>add</v-icon>
      Add Filter
    </v-btn>
  </div>
</template>

<script>
export default {
  name: "filters",
  props: {
    filters: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {
      channelsData: [
        {
          name: "Web",
          value: "web",
        },
        {
          name: "Android",
          value: "mobile-android",
        },
        {
          name: "iOS",
          value: "mobile-ios",
        },
        {
          name: "Facebook",
          value: "facebook",
        },
        {
          name: "What's App",
          value: "whatsapp",
        },
        {
          name: "Twitter",
          value: "twitter",
        },
        {
          name: "Instagram",
          value: "instagram",
        },
      ],
      operators: [
        {
          name: "Is",
          value: "is",
        },
        {
          name: "Is Not",
          value: "is not",
        },
        {
          name: "Start With",
          value: "start with",
        },
        {
          name: "Greater Than",
          value: ">",
        },
        {
          name: "Less Than",
          value: "<",
        },
        {
          name: "Matches",
          value: "matches",
        },
      ],
    };
  },
  methods: {
    addFilter() {
      this.filters.push({
        attribute: "",
        operator: "is",
        value: "",
        condition: "or",
      });
    },
    deleteFilter(index) {
      this.filters.splice(index, 1);
    },
  },
  computed: {
    variables() {
      return this.$store.state.blocksBuild.variables;
    },
  },
};
</script>

<style scoped></style>
